<template>
  <v-container class="fill-height" fluid>
    <v-row justify="center">
      <v-col cols="12" sm="8" md="4">
        <v-card class="pa-5" style="opacity: 0.88">
          <div v-if="data.step == 'forgot-password'" class="title text-center">Start Password Reset</div>
          <div v-else-if="data.step == 'reset-password-done'" class="title text-center">Reset Password Instructions</div>
          <div v-else class="title text-center">{{ $t("terarra-user-agent-login") }}</div>

          <v-card-text>
            <v-window v-model="data.step">
              <v-window-item :value="'login'">
                <v-card-text>
                  <v-form aria-autocomplete="off" autocomplete="off" @submit.prevent="authenticate" v-on:submit.prevent>
                    <v-text-field autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" :label="$t('email-as-username')" name="login" prepend-icon="mdi-account" v-model="user.username" type="text" hint="Your valid email account" :persistent-hint="true"></v-text-field>

                    <v-text-field id="password" :label="$t('password')" v-model="user.password" name="password" prepend-icon="mdi-lock" :type="showPassword ? 'text' : 'password'" :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'" @click:append="togglePassword" @keyup.enter="authenticate()"></v-text-field>
                  </v-form>
                </v-card-text>
              </v-window-item>

              <v-window-item :value="'forgot-password'">
                <v-card-text>
                  <v-form aria-autocomplete="off" autocomplete="off" @submit.prevent="authenticate" v-on:submit.prevent>
                    <v-text-field :label="$t('enter-your-username')" :persistent-hint="true" :hint="$t('we-will-send-email-to-address-associated-with-this-username')" name="username" prepend-icon="mdi-account" v-model="user.username" type="text"></v-text-field>
                  </v-form>
                </v-card-text>
              </v-window-item>
              <v-window-item :value="'reset-password-done'">
                <v-card-text>
                  <p>{{ $t("we-have-emailed-instructions-on-how-to-reset-password-associated-with-this-account") }}.</p>
                  <p>{{ $t("if-you-do-not-receive-email-in-next-few-minutes-please-check-spam-folder-or-contact-us-for-assistance") }}</p>
                </v-card-text>
              </v-window-item>
            </v-window>

            <div class="m-4 red--text" v-if="errorMessage">{{ errorMessage }}</div>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" v-if="data.step == 'login'" :disabled="processing" @keyup.enter="authenticate()" type="submit" @click="authenticate()">{{ processing ? "$t('authenticating')" : $t("login") }}</v-btn>

            <v-btn color="primary" v-if="data.step == 'forgot-password'" :disabled="processing" @keyup.enter="resetPassword()" type="submit" @click="resetPassword()">{{ processing ? $t("processing") : $t("reset-password") }}</v-btn>
            <v-btn color="primary" v-if="data.step == 'reset-password-done'" :disabled="processing" @click="data.step = 'login'">{{ $t("go-to-login") }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn @click="data.step = 'forgot-password'" v-if="data.step == 'login'">{{ $t("forgot-password") }}?</v-btn>
            <v-btn @click="data.step = 'login'" v-if="data.step != 'login'">{{ $t("back") }}</v-btn>
          </v-card-actions>
          <v-card-actions>
            {{ $t("new-to-terrara") }}?
            <v-btn to="/register" color="secondary" type="button" text>{{ $t("join") }} </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import {Component, Vue} from "vue-property-decorator"
import {cacheSrv} from "../cache/cache"
import router from "./../../router"
import {loginService} from "./login-service"
import {profileService} from "./profile-service"
import {userService} from "./user-service"
import {config, utils} from "../utils"
import axios from "axios"

@Component({
  components: {},
})
export default class Login extends Vue {
  ssoApiUrl = config.VUE_APP_SSO_API
  homeUrl = config.VUE_APP_APP_URL

  user = {
    username: "",
    password: "",
  }
  showPassword = false
  data: any = {
    step: "login",
  }

  submitted = false
  processing = false
  errorMessage = ""
  passwordError = false
  error = {
    msg: "",
  }

  constructor() {
    super()
  }

  togglePassword() {
    this.showPassword = !this.showPassword
  }

  async authenticate() {
    //Clean up stored profile
    cacheSrv.remove("profile")

    console.log("authenticate")
    this.errorMessage = ""
    this.processing = true
    let result

    if (!this.user.password) {
      this.errorPass()
      this.errorMessage = "Please enter username and password"
      this.processing = false
      return
    }

    try {
      result = await loginService.login({username: this.user.username.trim(), password: this.user.password.trim()})
      this.processing = false
      if (result) {
        let data = result

        if (data.error) {
          this.errorPass()
          console.log("Error in validating number")
          this.errorMessage = data.message
          return
        }

        if (data["token"]) {
          this.errorMessage = ""
          await userService.initUser()
          let authInfo = await profileService.authorize()

          if(!authInfo){
            console.log("Auth failed")
            this.errorPass()
            this.errorMessage = "Error authenticating user. Please try again"
            return
          }

          setTimeout(function () {
            router.push("/")
          }, 888)
        } else {
          console.log("no token")
          this.errorPass()
        }
      } else {
        console.log("Error in validating username. No data")
      }
    } catch (e) {
      console.log("error logging in", e)
      this.errorPass()
      this.processing = false
      this.errorMessage = "Error procesing your request. Please check your internet connection and try again"
      return
    }
  }

  errorPass() {
    this.passwordError = true
    setTimeout(() => {
      this.passwordError = false
    }, 1600)
  }

  async resetPassword() {
    this.errorMessage = ""
    this.processing = true
    let result
    if (!this.user.username) {
      this.errorPass()
      this.errorMessage = "Please enter username"
      this.processing = false
      return
    }

    try {
      result = await axios.post(`${this.ssoApiUrl}/api/admin/request-reset-password`, {
        username: this.user.username.trim(),
        targeturl: this.homeUrl,
      })
    } catch (e) {
      console.log("error", e)
      this.errorPass()
      console.log("Error while reseting pass")
      this.processing = false
      this.errorMessage = "Error procesing your request. Please check your internet connection and try again"
      return
    }

    this.processing = false
    if (result.data) {
      let data = result.data
      console.log("data", data)

      if (data.error == true) {
        this.errorPass()
        console.log("Error in resettng pass")
        this.errorMessage = data.message
        return
      }

      this.errorMessage = ""
      this.data.step = "reset-password-done"
    } else {
      console.log("Error in validating username. No data")
    }
  }
}
</script>
